import { Duration } from "luxon";

import { queryOptions } from "@react/foundation/query";

import { API } from "../../bootstrap/api.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useUnauthenticatedQueries() {
  return {
    getHealthProbesQueryOptions: queryOptions({
      queryFn: API.monitoringPublic.getHealthProbes,
      queryKey: {
        group: data => ["api.monitoringPublic.getHealthProbes", data.target],
        variant: data => [data.order, data.cursor, data.limit],
      },
      refetchInterval: Duration.fromObject({ minutes: 1 }).as("milliseconds"),
    }),
  };
}
